'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');
var classNames = require('classnames');

//the input fields value can be grabbed by assigning a ref in the parent component to the field component
//then doing the following "var email = ReactDOM.findDOMNode(this.refs.email).children[0].value;"

var FloatLabelField = function (_React$Component) {
    _inherits(FloatLabelField, _React$Component);

    function FloatLabelField() {
        var _temp, _this, _ret;

        _classCallCheck(this, FloatLabelField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            isPopulatedFlag: _this.props.initialValue ? true : false,
            error: '',
            initialValue: _this.props.initialValue,
            errorForADA: ''
        }, _this.isPopulated = function (e, extraData) {
            var isPopulatedFlag = e.currentTarget.value != '' ? true : false;
            if (_this.state.isPopulatedFlag != isPopulatedFlag) {
                _this.setState({
                    isPopulatedFlag: isPopulatedFlag
                });
            }
            if (_this.props.onChangeHandler) {
                var error = _this.props.onChangeHandler(e.currentTarget.value, extraData);
                if (error != _this.state.error) {
                    _this.setState({ error: error });
                }
            }
        }, _this.validationFunctionHandler = function (e) {
            var error = '';
            if (_this.props.validationFunction) {
                error = _this.props.validationFunction(e.currentTarget.value);
                if (error != _this.state.error) {
                    _this.setState({ error: error });
                }
            }
            if (_this.props.onChangeHandler) {
                error = _this.props.onChangeHandler(e.currentTarget.value);
                if (error != _this.state.error) {
                    _this.setState({ error: error });
                }
            }
            if (error) {
                _this.refs.ADAText.focus();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FloatLabelField.prototype.render = function render() {
        var name = this.props.placeHolder.replace(/ /g, "_");

        var labelClasses = classNames({
            show: this.state.isPopulatedFlag || this.state.error ? true : false,
            'label-error': this.state.error ? true : false
        });

        return React.createElement(
            'div',
            { className: "field--wrapper col-xs-12 " + this.props.customClass },
            React.createElement('input', _extends({ required: this.props.required,
                className: this.state.error ? "label-error" : '',
                type: this.props.type,
                defaultValue: this.state.initialValue,
                id: name,
                onChange: this.isPopulated,
                onBlur: this.validationFunctionHandler
            }, this.props.inputAttributes)),
            React.createElement(
                'label',
                _extends({ className: labelClasses, htmlFor: name }, this.props.labelAttributes),
                this.props.placeHolder,
                React.createElement(
                    'span',
                    { className: 'label-error-span' },
                    ' ',
                    this.state.error
                )
            ),
            React.createElement(
                'div',
                { ref: 'ADAText', style: { width: 0, height: 0, overflow: "hidden" } },
                this.props.placeHolder + " " + this.state.errorForADA
            )
        );
    };

    return FloatLabelField;
}(React.Component);

FloatLabelField.propTypes = {
    placeHolder: PropTypes.string.isRequired, //The label/placeholder text to use
    validationFunction: PropTypes.func, //takes the inputs string to run validation against. if error return string with error text
    customClass: PropTypes.string, //custom class if field needs to be unique
    type: PropTypes.string, //if the input field needs a special type such as email or phone number
    required: PropTypes.bool, //turns on or off the required field
    initialValue: PropTypes.string, //if there is need to have an initial value populated (will clear when user leaves fields focus)
    onChangeHandler: PropTypes.func, //if validation is needed on every key press then pass this prop in
    inputAttributes: PropTypes.shape({}), //any other DOM attributes to be added to the input
    labelAttributes: PropTypes.shape({}) //any other DOM attributes to be added to the label
};
FloatLabelField.defaultProps = {
    customClass: '',
    type: 'text'
};


module.exports = FloatLabelField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/FloatLabelField.js
// module id = 102
// module chunks = 0